import { render } from "./TaskTypesList.vue?vue&type=template&id=51524c54&scoped=true"
import script from "./TaskTypesList.vue?vue&type=script&lang=js"
export * from "./TaskTypesList.vue?vue&type=script&lang=js"

import "./TaskTypesList.vue?vue&type=style&index=0&id=51524c54&scoped=true&lang=css"

import exportComponent from "C:\\creatorcube-vue3\\CreatorCUBE\\CreatorCUBE_Controller\\ClientApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51524c54"]])

export default __exports__